import moment from 'moment';

// Table cols for Assemblies and Parts Table
export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  rearrangeCols: false,
  isCheckable: false,
  // stickeyHeaders: true,
  gutterOpts: {
    buttons: [
      // {
      //   event: 'columnChooser',
      //   icon: 'icon-tablecolumns',
      //   tooltip: 'Customize Columns',
      //   isLine: true,
      // }
    ],
  },
  toolBar: {
    buttons: [
      {
        event: 'openActivity',
        icon: 'icon-activityhistory',
        tooltip: 'Activity History',
        isLine: true,
      },
      {
          event: 'addNew',
          icon: 'icon-addnew',
          isLine: true,
          tooltip: 'Add New',
          isDisabled: ({ stage }) => !stage || stage === 'complete',
          permissionModule: 'app&projects',
          alterDataKey: 'alterProject',
        },
        {
          event: 'excelImport',
          icon: 'icon-importexcel',
          tooltip: 'Import From Excel',
          isLine: true,
          permissionModule: 'app&projects',
          alterDataKey: 'alterProject',
        },
    ],
    bulkActions: () => { },
  },
  fields: [
    {
      title: 'Project',
      name: 'project',
      width: '400px',
      id: 'name',
      sortField: 'name',
      prop: 'name',
      defaultVisible: true,
      openCard: true
    },
    {
      title: 'Company',
      name: 'company',
      sortField: 'company',
      width: '400px',
      id: 'createdCompany',
      prop: 'createdCompany.name',
      defaultVisible: true,
    },
    {
      name: 'createdAt',
      width: '152px',
      title: 'Created',
      id: 'createdAt',
      prop: 'createdAt',
      sortField: 'createdAt',
      defaultVisible: true,
      formatter(val) {
        return moment(val).format('MM/DD/YYYY')
      },
    },
    {
      title: 'Status',
      name: 'status',
      width: '152px',
      id: 'status',
      prop: 'status',
      sortField: 'status',
      defaultVisible: true,
    },
    {
      name: 'projectId',
      width: '192px',
      title: 'Project ID',
      id: 'projectId',
      sortField: 'projectSettings.0.customId',
      prop: 'projectSettings.0.customId',
      defaultVisible: true,
    },
    {
      title: 'Actions',
      name: 'table-field-actions',
      id: 'action',
      hideFromChooser: true,
      alwaysVisible: false,
      defaultVisible: true,
      width: '112px',
      // sticky: true,
      // clearBtn: true,
      // searchable: true,
      // hideAllFilters: false,
      permissionModule: 'app&projects',
      permissionKey: 'assembly_parts',
      // thAttrs: () => ({ class: 'action-sticky' }),
      // tdClass: 'action-sticky',
      inputProps: {
        showEdit: true,
        options() {
          return [
            {
              icon: 'icon-user',
              label: 'Teams',
              event: 'projectTeam',
            },
            {
              icon: 'icon-bullhorn',
              label: 'Notify Users',
              event: 'notifyUsers',
            },
            {
              icon: 'icon-activityhistory',
              label: 'Activities',
              event: 'activity',
            },
            {
              icon: 'icon-bin',
              label: 'Archive',
              event: 'archiveProject',
              permissionModule: 'app&projects',
              alterDataKey: 'alterProject',
            },
          ];
        },
      },
    },
  ],
};
